import React, { useEffect } from 'react'
import Control from '../store/control';
// BK
import WorkflowTestBk from './workflowTestBk';
import WorkflowFinalBk from './workflowFinalBk';
import WorkflowBKFinalStep from './workflowBKFinalStep';
// AK
import WorkflowTestAk from './workflowTestAk';
import WorkflowFinalAk from './workflowFinalAk';
import WorkflowSoftInsert from './workflowSoftInsert';


const SideWorkflow = () => {
  const type = Control.Get('type');
  const prosthetics = Control.Get('prosthetics');
  const setControl   = Control.Get('setControl');

  switch(type) {
    case '':
      return null;
    case 'TestSocket':
      setControl(s => {s.tsfd = 'ts'})
      if (prosthetics == 'BK') {
        return <WorkflowTestBk/>;
      } else if (prosthetics == 'AK') {
        return <WorkflowTestAk/>;
      }
    case 'FinalDevice':
      setControl(s => {s.tsfd = 'fd'})
      if (prosthetics == 'BK') {
        return <WorkflowTestBk/>;
      } else if (prosthetics == 'AK') {
        return <WorkflowTestAk/>; // test and final fitting is almost same, only assemble function is different.
      }
    case 'FinalDeviceFinalStep':
      return <WorkflowBKFinalStep/>;
    case 'SoftInsert':
      return <WorkflowSoftInsert/>;
    default:
      return 'Unknown step';
  }
}
export default SideWorkflow;
